import React, { createContext, useContext, useState } from 'react'

const IsLoggedContext = createContext()

const IsLoggedProvider = ({ children }) => {
  const [isLogged, setIsLogged] = useState(false)

  return (
    <IsLoggedContext.Provider value={{ isLogged, setIsLogged }}>
      {children}
    </IsLoggedContext.Provider>
  )
}

const useIsLogged = () => {
  const context = useContext(IsLoggedContext)

  if (!context) {
    throw new Error('useIsLogged must be used within an IsLoggedProvider')
  }
  return context
}

export { IsLoggedProvider, useIsLogged }
